import { useState, useEffect } from "react";
import axios from "axios";

const baseUrl =
  process.env.REACT_APP_PUBLIC_API_URL ||
  process.env.REACT_APP_API_URL; 


  
function formatTimeAgo(isoString) {
  if (!isoString) return "—";
  const then = new Date(isoString).getTime();
  const now = Date.now();
  const diffMs = now - then;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return "just now";
  if (diffMins < 60) return `about ${diffMins} min${diffMins === 1 ? "" : "s"} ago`;
  if (diffHours < 24) return `about ${diffHours} hour${diffHours === 1 ? "" : "s"} ago`;
  if (diffDays < 7) return `about ${diffDays} day${diffDays === 1 ? "" : "s"} ago`;
  return new Date(isoString).toLocaleDateString();
}

const RecentActivityCard = () => {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${baseUrl}/recent-activity`)
      .then((response) => {
        const resData = response.data;
        if (resData.success && resData.activities) {
          setActivities(resData.activities);
        }
      })
      .catch((error) => console.error("Error fetching recent activity:", error))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="bg-white rounded-2xl p-6 shadow-sm h-full">
      <h2 className="text-lg font-semibold mb-4">Recent Activity</h2>

      {loading ? (
        <p className="text-sm text-gray-500">Loading...</p>
      ) : activities.length === 0 ? (
        <p className="text-sm text-gray-500">No recent registrations yet.</p>
      ) : (
        <div className="space-y-3">
          {activities.map((item, index) => (
            <div
              key={index}
              className="flex items-center justify-between bg-gray-50 rounded-xl p-3"
            >
              <div>
                <p className="font-medium text-sm">{item.name}</p>
                <p className="text-xs text-gray-500">{item.region || "—"}</p>
                <p className="text-xs text-gray-400">
                  {formatTimeAgo(item.createdAt)}
                </p>
              </div>

              <span className="text-xs font-medium px-3 py-1 rounded-full bg-green-100 text-green-700">
                Complete
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default RecentActivityCard;
